const state = {
  tableX: 0,
  tableY: 0
}

const mutations = {
  setTablePos(state, [x, y]) {
    state.tableX = x
    state.tableY = y
  }
}

const getters = {
  tableX(state) {
    return state.tableX
  },
  tableY(state) {
    return state.tableY
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
